import { useId as useId$1, computed, toValue } from "vue";
const useId = (id, suffix) => {
  const genId = useId$1();
  return computed(() => toValue(id) || `__BVID__${genId}___BV_${suffix}__`);
};
export {
  useId as u
};
//# sourceMappingURL=useId-BrAgQfKM.mjs.map
